import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Backdrop = styled.View`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.55);
  justify-content: center;
  align-items: center;
  padding: ${RFValue(24)}px;
`;

export const Card = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(28)}px ${RFValue(24)}px;
  align-items: center;
  width: 100%;
`;

export const SpinnerWrapper = styled.View`
  width: ${RFValue(56)}px;
  height: ${RFValue(56)}px;
  border-radius: ${RFValue(28)}px;
  background-color: ${({theme}) => theme.colors.primary};
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(20)}px;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  text-align: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const Description = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(13)}px;
  text-align: center;
  line-height: ${RFValue(20)}px;
`;
